<template>
  <span
    style="margin: 0"
    class="form-error is-visible"
    data-test="label"
  >{{ label }}</span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
